export default __webpack_public_path__ + "static/media/location-pin2.850defbf.svg";